import { useMemo } from "react";
import {
  CarSlotProvider,
  defaultCarSlots,
  CoreCarsComponent,
} from "@b2bportal/core-cars";
import { PackageBreadcrumbs } from "@tenant/packages";
import {
  CarAvailabilityLink,
  CarAvailabilityCard,
  PackageCarShopBookingSection,
} from "../components";

export const PackagesCarSlotProvider = ({
  children,
}: React.PropsWithChildren) => {
  const slotComponents = useMemo(
    () => ({
      ...defaultCarSlots(),
      [CoreCarsComponent.CarAvailabilityLink]: CarAvailabilityLink,
      [CoreCarsComponent.CarAvailabilityCard]: CarAvailabilityCard,
      [CoreCarsComponent.CarShopBookingSection]: PackageCarShopBookingSection,
      [CoreCarsComponent.CarBreadcrumbs]: PackageBreadcrumbs,
      // We don't want car search in the package flow
      [CoreCarsComponent.CarAvailabilitySearch]: () => null,
    }),
    []
  );

  return (
    <CarSlotProvider
      context={{
        components: slotComponents,
        providerName: "package-cars",
      }}
    >
      {children}
    </CarSlotProvider>
  );
};
